import Phaser from 'phaser';
import { ASSET_KEYS, SCENE_KEYS, TEXTURE_KEYS } from '@/config/constants';
import { getOtamaAssetUrl, OTAMA_IMAGE_FILES, OtamaAssetKey } from '@/config/otamaAssets';
import { useGameStore } from '@/store/gameStore';
import ottoCharacterUrl from '@/assets/images/characters/otto.png';
import ottoFaceUrl from '@/assets/images/characters/otto-face.png';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super(SCENE_KEYS.preload);
  }

  preload() {
    if (!this.textures.exists(ASSET_KEYS.ottoCharacter)) {
      this.load.image(ASSET_KEYS.ottoCharacter, ottoCharacterUrl);
    }

    if (!this.textures.exists(ASSET_KEYS.ottoFace)) {
      this.load.image(ASSET_KEYS.ottoFace, ottoFaceUrl);
    }

    Object.keys(OTAMA_IMAGE_FILES).forEach((key) => {
      const assetKey = key as OtamaAssetKey;

      if (!this.textures.exists(assetKey)) {
        this.load.image(assetKey, getOtamaAssetUrl(assetKey));
      }
    });
  }

  create() {
    useGameStore.getState().setStatus('Generando texturas y runtime FX');

    if (!this.textures.exists(TEXTURE_KEYS.particle)) {
      const particle = this.add.graphics();
      particle.fillStyle(0xffffff, 1);
      particle.fillCircle(12, 12, 12);
      particle.generateTexture(TEXTURE_KEYS.particle, 24, 24);
      particle.destroy();
    }

    if (!this.textures.exists(TEXTURE_KEYS.glow)) {
      const glow = this.add.graphics();
      glow.fillStyle(0x4fd1ff, 0.7);
      glow.fillCircle(18, 18, 18);
      glow.generateTexture(TEXTURE_KEYS.glow, 36, 36);
      glow.destroy();
    }

    this.scene.start(SCENE_KEYS.gameplay);
  }
}
